import { useState } from "react";
import DosageCalculator from "./DosageCalculator";
import Bible, { PEPTIDES } from './Bible';
import StackBuilder from "./StackBuilder";
// import ProtocolFinder from "./ProtocolFinder"; // restore when Protocols is rebuilt
import UnderConstruction from "./UnderConstruction";
import Bioavailability from "./Bioavailability";
import PharosVaultConsentGate from "./PharosVaultConsentGate";
import VaultHero from "./VaultHero";

export default function App() {
  const [page, setPage] = useState("bible");
  const tabs = [
    { id:"finder",      label:"🧬 PROTOCOLS" },
    { id:"bio",         label:"📊 BIOAVAIL" },
    { id:"calculator",  label:"💉 DOSAGE" },
    { id:"stacks",      label:"⚡ STACKS" },
    { id:"bible",       label:"📖 BIBLE" },
  ];
  return (
    <PharosVaultConsentGate>
    <div>
      <VaultHero />
      <div style={{ display:"flex", gap:0, background:"#0a0a0a", borderBottom:"2px solid #dc2626", position:"sticky", top:0, zIndex:100 }}>
        {tabs.map(t => (
          <button key={t.id} onClick={() => setPage(t.id)} style={{
            flex:1, padding:"11px 4px",
            background: page === t.id ? "#dc2626" : "transparent",
            border:"none", color: page === t.id ? "#fff" : "#6b7280",
            cursor:"pointer", fontSize:11, letterSpacing:"0.06em",
            fontFamily:"'Impact','Arial Black',sans-serif", transition:"all 0.15s",
          }}>{t.label}</button>
        ))}
      </div>
      {page === "finder"     && <UnderConstruction section="Protocol Finder" onGo={setPage} />}
      {page === "bio"        && <Bioavailability compounds={PEPTIDES} />}
      {page === "calculator" && <DosageCalculator />}
      {page === "stacks"     && <StackBuilder />}
      {page === "bible"      && <Bible />}
    </div>
    </PharosVaultConsentGate>
  );
}
